import { loadersSelector, phonecodesSelector } from './root';
import { propNameSelector } from '../utils';

export const phoneCodesListSelector = propNameSelector(phonecodesSelector, 'list');
export const pagingPhoneCodesSelector = propNameSelector(phonecodesSelector, 'paging');
export const sortingPhoneCodesSelector = propNameSelector(phonecodesSelector, 'sorting');
export const countPhoneCodesSelector = propNameSelector(phonecodesSelector, 'count');
export const loaderPhoneCodesSelector = propNameSelector(loadersSelector, 'phonecodes');
